import React from 'react';
import { AllowedShortcuts } from '@/platform/shortcuts/operator-shortcuts';
import { createStyles } from '@/contexts/theme-context';
import { FONTS } from '@/styles';
import {
  getAppropriateShortcutKey,
  getModifierKey,
} from '@platform/shortcuts/utils/keyboard-platform';
import { getShortcutTitle } from '@platform/shortcuts/utils';
import { SvgProps } from 'react-native-svg';
import { Text, View } from 'react-native';

interface Props {
  hotKey: AllowedShortcuts | string[];
  Icon?: Array<React.ComponentType<SvgProps>>;
}

export const ShortcutDetailsRow: React.FC<Props> = ({ hotKey, Icon }) => {
  const [styles, theme] = useStyles();

  const modifierKey = getModifierKey(hotKey);
  const title = getShortcutTitle(hotKey);
  const shortcut = getAppropriateShortcutKey(hotKey);

  const textStyle = [FONTS.primarySemiBold, styles.baseText];
  return (
    <View style={styles.gridItem}>
      <Text style={textStyle}>{title}</Text>
      <View style={styles.shortcutContainer}>
        {modifierKey ? (
          <>
            <Text style={[textStyle, styles.shortcut]}>{modifierKey}</Text>
            <Text style={textStyle}>+</Text>
          </>
        ) : null}
        {Icon ? (
          <View style={styles.iconContainer}>
            {Icon.map((IconComponent, index) => (
              <View key={index} style={styles.shortcut}>
                <IconComponent
                  height={14}
                  stroke={theme.sk.color.icon.primary}
                  width={14}
                />
              </View>
            ))}
          </View>
        ) : (
          <Text style={[textStyle, styles.shortcut]}>{shortcut}</Text>
        )}
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  baseText: {
    color: theme.colors.primary,
    fontSize: 14,
  },
  gridItem: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: 10,
  },
  iconContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 4,
  },
  shortcut: {
    borderColor: theme.colors.divider,
    borderRadius: 4,
    borderWidth: 1,
    paddingHorizontal: 8,
    paddingVertical: 4,
    textTransform: 'capitalize',
  },
  shortcutContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: 4,
  },
}));
